export class DropdownItem {
    key: any;
    value: string;
    extra?: string;
    object?: any;
    icon?: string;
}